import { SitesGetSiteByIdSiteModel, useDeleteSite } from "api";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import DeleteButton from "shared/components/DeleteButton";

interface Props {
  site: SitesGetSiteByIdSiteModel;
}

function DeleteSiteForm({ site }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { mutate, error, ...status } = useDeleteSite();

  return (
    <DeleteButton
      item="Site"
      status={status}
      error={error}
      onConfirm={() => {
        mutate(
          {
            siteId: site.id!,
          },
          {
            onSuccess: () => {
              enqueueSnackbar("Site deleted", {
                variant: "success",
              });
              navigate(`/sites`);
            },
          }
        );
      }}
    />
  );
}

export default DeleteSiteForm;
